module.exports = __webpack_public_path__ + "static/media/Intersection 32.a3b0a48d.png";